// Author YuJiaBei
// Date 2020-10-10 15:06:10

class SithMesMstBottleneck {
constructor({
        id = null,
        mstLocationId = '',
        mstLocationName = '',
        bnPriority = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.bnPriority = bnPriority;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstBottleneck();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'mstLocationId',
        label: 'label.sith.mst.sithMesMstBottleneck.grid.mstLocationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstBottleneck.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bnPriority',
        label: 'label.sith.mst.sithMesMstBottleneck.grid.bnPriority',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstBottleneck.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    mstLocationIdFilter : "",
    bnPriorityFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstLocationIdFilter',
        label: 'label.sith.mst.sithMesMstBottleneck.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'bnPriorityFilter',
        label: 'label.sith.mst.sithMesMstBottleneck.filter.bnPriority',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstBottleneck.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'bnPriority',
        label: 'label.sith.mst.sithMesMstBottleneck.entity.bnPriority',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstBottleneck.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstBottleneck, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
